/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { promptsControllerCreate } from "./promptsControllerCreate";
import { promptsControllerFindAll } from "./promptsControllerFindAll";
import { promptsControllerFindAllVersions } from "./promptsControllerFindAllVersions";
import { promptsControllerFindOne } from "./promptsControllerFindOne";
import { promptsControllerRemove } from "./promptsControllerRemove";
import { promptsControllerUpdate } from "./promptsControllerUpdate";

export function promptsService() {
  return { promptsControllerCreate, promptsControllerFindAll, promptsControllerFindOne, promptsControllerUpdate, promptsControllerRemove, promptsControllerFindAllVersions }
}